import { render } from "./red3.vue?vue&type=template&id=366980a9&scoped=true"
import script from "./red3.vue?vue&type=script&lang=js"
export * from "./red3.vue?vue&type=script&lang=js"

import "./red3.vue?vue&type=style&index=0&id=366980a9&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366980a9"]])

export default __exports__